import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyUserContext } from 'application/contexts/useCompanyUser';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { CompanyUserLogout } from 'application/usecases/CompanyUserLogout';

export const useHeader = () => {
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const companyUserLogout = diContainer.resolve(CompanyUserLogout);

    const { user, resetUser } = useContext(companyUserContext);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleLogout = async () => {
        await companyUserLogout.execute();
        window.location.href = '/company/login/';
        resetUser();
    };

    const menuItems = [
        { text: 'マイページ', url: '/company/dashboard/' },
        { text: '企業を追加', url: '/company/add_company/' },
        { text: 'ログアウト', url: '/company/login/', handler: handleLogout },
    ];

    const onItemClick = (item: (typeof menuItems)[0]) => {
        setPopoverOpen(false);
        item.handler?.();
        if (item.url) navigate(item.url);
    };

    return {
        user,
        popoverOpen,
        setPopoverOpen,
        menuItems,
        onItemClick,
    };
};
